import { translate } from '../translation';

export const cloneTemplate = (templates, name) => {
  const template = templates[name];
  if (!template) {
    throw new Error(`Template "${name}" not found`);
  }
  return document.importNode(template.content, true);
};

export const applyVisibility = (element, isVisible) => {
  if (!isVisible) {
    element.classList.add('d-none');
  }
};

export const applyOptionState = (element, state) => {
  const input = element.querySelector('input');
  const label = element.querySelector('span');
  const container = element.querySelector('li');

  input.value = state.id;
  input.checked = state.isSelected;
  input.disabled = state.isDisabled || false;

  label.innerHTML = state.label;

  applyVisibility(container, state.isVisible);
};

export const applyGroupState = (element, state) => {
  const groupId = `group-${state.id}`;
  const list = element.querySelector('.option-group__list');
  const title = element.querySelector('.option-group__title');
  const container = element.querySelector('li');

  list.setAttribute('aria-labelledby', groupId);

  title.setAttribute('id', groupId);
  title.textContent = state.label;

  applyVisibility(container, state.isVisible);
};

export const applySelectedOptionsState = (element, fieldId) => {
  const list = element.querySelector('.selected-options__list');
  const label = element.querySelector('.selected-options__label');
  const groupId = `selected-options-${fieldId}`;

  list.setAttribute('aria-labelledby', groupId);

  label.setAttribute('id', groupId);
};

export const createSubList = (isVisible) => {
  const subList = document.createElement('ul');
  subList.classList.add('list-unstyled', 'ps-3');

  applyVisibility(subList, isVisible);

  return subList;
};

export const addNoResultsOptionIfNeeded = (fragment, options, isSearching) => {
  if ((!isSearching && options.length > 0) || options.some((option) => option.display === true)) {
    return;
  }

  const noResultsElement = document.createElement('li');
  noResultsElement.classList.add('px-3', 'py-2');
  noResultsElement.textContent = translate('common.select_field.no_results');
  fragment.appendChild(noResultsElement);
};
